module.exports = __webpack_public_path__ + "static/image_02_b@2x-a6044e39e093336137fe5e5cfbfc10eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/trusona/image_02_b@2x.png
// module id = 419
// module chunks = 3627797113349 20562973939449 33019919093843